import * as React from "react";
import { useCallback, useState, useMemo } from "react";
import DisableSubmissionStateContext from "./DisableSubmissionStateContext";
const DisableSubmissionStateProvider = ({ children }) => {
  const [isDisabledMap, setIsDisabledMap] = useState({});
  const setDisabled = useCallback(
    (sectionKey, disabled2) => {
      if (Boolean(isDisabledMap[sectionKey]) !== disabled2) {
        setIsDisabledMap({
          ...isDisabledMap,
          [sectionKey]: disabled2
        });
      }
    },
    [isDisabledMap]
  );
  const disabled = Object.values(isDisabledMap).includes(true);
  const contextValue = useMemo(() => ({ disabled, setDisabled }), [disabled, setDisabled]);
  return /* @__PURE__ */ React.createElement(DisableSubmissionStateContext.Provider, { value: contextValue }, children);
};
export default DisableSubmissionStateProvider;
